import { render, staticRenderFns } from "./AttributesTemplate.vue?vue&type=template&id=77146efc&scoped=true"
import script from "./AttributesTemplate.vue?vue&type=script&lang=js"
export * from "./AttributesTemplate.vue?vue&type=script&lang=js"
import style0 from "./AttributesTemplate.vue?vue&type=style&index=0&id=77146efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77146efc",
  null
  
)

export default component.exports